<template>
  <div v-if="user">
    <h1>APIS</h1>
    <div v-if="apis">
      <div class="array-wrapper" v-for="(api, index) in apis" :key="index">
          <div class="array-item"><b>Name:</b><br>{{ api.name }}</div>
          <div class="array-item"><b>Last update:</b><br>{{ api.last_update }}</div>
          <div class="array-item"><b>Update time:</b><br>{{ convertSeconds(api.update_time).format }}</div>
          <div class="array-item"><b>Title:</b><br>{{ api.title }}</div>
          <div class="array-item"><b>URL:</b><br>{{ api.url }}</div>
          <div class="array-item"><b>Type:</b><br>{{ api.type }}</div>
          <div class="array-item">
            <div>
              <b>Data: </b>
              <button @click="showData[api.id] = !showData[api.id]" type="button" class="btn simple">
                <template v-if="showData[api.id]">Show data</template>
                <template v-if="!showData[api.id]">Hide data</template>
              </button>
            </div>
            <template v-if="showData[api.id]">
              <div class="indent-20"></div>
              <textarea class="data-textarea" v-model="api.data"></textarea>
            </template>
          </div>
          <button @click="updateApi(api.id, api.value, api.key)" type="button" class="btn primary" :disabled="loading[api.id]">
            <template v-if="loading[api.id]">Loading...</template>
            <template v-else>Update data now</template>
          </button>
      </div>
    </div>
  </div>
</template>

<script>
import {axiosDB} from "./../axios/index";
import {mapGetters} from "vuex";
import {EActionDB, ETableDB} from "@/enums/enums";

export default {
  computed: {
    ...mapGetters(['config', 'user', 'apis', 'sites']),
  },
  data() {
    return {
      showData: [],
      loading: [],
    }
  },
  methods: {
    convertSeconds(seconds) {
      const years = Math.floor(seconds / (365 * 24 * 60 * 60));
      seconds -= years * (365 * 24 * 60 * 60);

      const days = Math.floor(seconds / (24 * 60 * 60));
      seconds -= days * (24 * 60 * 60);

      const hours = Math.floor(seconds / (60 * 60));
      seconds -= hours * (60 * 60);

      const minutes = Math.floor(seconds / 60);
      seconds -= minutes * 60;

      return {
        years,
        days,
        hours,
        minutes,
        seconds,
        format: `${years > 0 ? years + ' years ' : ''}${days > 0 ? days + ' days ' : ''}${hours > 0 ? hours + ' hours ' : ''}${minutes > 0 ? minutes + ' minutes ' : ''}${seconds > 0 ? seconds + ' seconds' : ''}`.trim()
      };
    },
    updateApi(id, value) {
      this.loading[id] = true;
      const sites = this.sites;
      let apisValue;

      apisValue = sites.find(item => {
        return item.api_value === value
      });

      // console.log(apisValue.user_key)

      // this.loading[id] = false;
      axiosDB({
        table: ETableDB.APIS,
        action: EActionDB.UPDATE_API_DATA,
        id,
      },{
          value,
          key: apisValue.user_key
      },
      () => {
        this.loading[id] = false;
      })
    },
  }
}
</script>